module.exports = __webpack_public_path__ + "static/img/1.bbeb7ab3.png";